<template>
  <div class="content__column content__column--small" v-if="category">
    <h1 class="content__title">Editar / Crear Categoría</h1>
    <form class="form" @submit.prevent="saveCategory">
      <div class="form__fieldset">
        <div class="form__container">
          <label for="title_es" class="form__label form__label--required"
            >Nombre de la Categoría (Español)</label
          >
          <input
            type="text"
            class="form__input"
            name="title_es"
            id="title_es"
            v-model="category.title_es"
            v-validate="validation.title_es"
          />
          <span
            v-show="errors.has('title_es')"
            class="form__alert"
            v-text="errors.first('title_es')"
          ></span>
        </div>

        <div class="form__container">
          <label for="title_en" class="form__label form__label--required"
            >Nombre de la Categoría (Inglés)</label
          >
          <input
            type="text"
            class="form__input"
            name="title_en"
            id="title_en"
            v-model="category.title_en"
            v-validate="validation.title_en"
          />
          <span
            v-show="errors.has('title_en')"
            class="form__alert"
            v-text="errors.first('title_en')"
          ></span>
        </div>

        <div class="form__container">
          <label for="description_es" class="form__label"
            >Descripción (Español)</label
          >
          <textarea
            type="text"
            class="form__input"
            name="description_es"
            id="description_es"
            v-model="category.description_es"
            v-validate="validation.description_es"
          ></textarea>
          <span
            v-show="errors.has('description_es')"
            class="form__alert"
            v-text="errors.first('description_es')"
          ></span>
        </div>

        <div class="form__container">
          <label for="description_en" class="form__label"
            >Descripción (Inglés)</label
          >
          <textarea
            type="text"
            class="form__input"
            name="description_en"
            id="description_en"
            v-model="category.description_en"
            v-validate="validation.description_en"
          ></textarea>
          <span
            v-show="errors.has('description_en')"
            class="form__alert"
            v-text="errors.first('description_en')"
          ></span>
        </div>

        <div class="form__container">
          <label class="form__label form__label--required" for="status_id">
            Estatus de la Categoría</label
          >
          <div class="form__select-container">
            <select
              name="status_id"
              id="status_id"
              class="form__select"
              v-validate="validation.status_id"
              v-model="category.status_id"
            >
              <option hidden :value="null">Seleccione un estatus</option>
              <option
                v-for="(status, index) in category_status"
                :key="index"
                :value="status.id"
                v-text="status.name"
              ></option>
            </select>
          </div>
          <span
            v-show="errors.has('status_id')"
            class="form__alert"
            v-text="errors.first('status_id')"
          ></span>
        </div>

        <div class="form__container" v-if="parents">
          <label class="form__label form__label--required" for="parent_id">
            Categoría superior</label
          >
          <div class="form__select-container">
            <select
              name="parent_id"
              id="parent_id"
              class="form__select"
              v-validate="validation.parent_id"
              v-model="category.parent_id"
            >
              <option :value="null">Sin categoría superior</option>
              <template v-for="(parent, index) in parents">
                <option
                  :key="index"
                  :value="parent.id"
                  v-text="parent.title_es"
                  v-if="parent.id !== category.id"
                ></option>
              </template>
            </select>
          </div>
          <span
            v-show="errors.has('parent_id')"
            class="form__alert"
            v-text="errors.first('parent_id')"
          ></span>
        </div>
      </div>
      <input
        type="submit"
        class="btn btn__action btn--regular"
        value="Guardar"
      />
      <button
        @click.prevent="$emit('new')"
        class="btn btn__transparent btn--regular"
      >
        Agregar Nueva Categoría
      </button>
    </form>
  </div>
</template>

<script>
import httpService from "@/core/api/request";
import { category_status } from "./mocks";
import mediaPopup from "@/components/media/popup";
import { config } from "@/core/config/base";
import Mixins from "./mixins";

export default {
  props: {
    category: {
      type: Object,
      required: false,
      default: function() {
        return {
          id: null,
          title_es: null,
          title_en: null,
          description_es: null,
          description_en: null,
          status_id: null,
          parent_id: null
        };
      }
    }
  },
  mixins: [httpService, Mixins],
  components: {
    mediaPopup
  },
  data: function() {
    return {
      category_status: category_status,
      validation: {
        title_es: "required|max:100",
        title_en: "required|max:100",
        status_id: "required|min_value:1|max:4",
        parent_id: "min_value:1|max:11"
      }
    };
  },
  mounted: function() {
    this.getParentCategories();
  },
  methods: {
    saveCategory: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.category.date = this.date + " " + this.time;
          let httpRequest = {
            params: "",
            module: "product_categories",
            element: this.category
          };
          let action;
          if (this.category.id) {
            action = this.put(this.category.id, httpRequest);
          } else {
            action = this.post(httpRequest);
          }
          action
            .then(response => {
              if (!this.category.id) {
                this.category.id = response.data.current_id;
              }
              this.$store.commit("elementChanged", {
                module: "categoryEdit",
                time: Math.round(new Date().getTime() / 1000)
              });
              this.$store.commit("notificate", {
                title: "CATEGORÍA GUARDADA",
                text: "La categoría ha sido guardada correctamente",
                type: "success"
              });
            })
            .catch(() => {
              this.$store.commit("notificate", {
                title: "CATEGORÍA NO GUARDADA",
                text:
                  "La categoría no ha sido guardada, por favor, intente más tarde",
                type: "error"
              });
            });
        }
      });
    }
  }
};
</script>

<style lang="sass">
@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/product_categories/edit.vue